import LangEnum from '../../../../../../lang/LangEnum';
import { Team } from '../../../../../../modules/context/ApplicationContext/applicationContext.types';
import { TeamSelectorGroup } from '../../components/TeamSelector/teamSelector.types';
import { BuildTeamGroupsParams } from './useUserMenu.types';

export const isBrand = (team: Team) => !!team.brand && !team.store;
export const isStore = (team: Team) => !!team.store;
export const isOther = (team: Team) => !team.brand && !team.store;
export const isNetworkAdmin = (team: Team) => team.role === 'ADMIN';

export const toMenuItem = (team: Team, selectedTeamId?: string) => ({
  id: team.id,
  name: team.brand?.name ?? team.store?.name ?? team.roleName,
  initial: (team.brand?.name ?? team.store?.name ?? team.name)?.[0]?.toUpperCase() ?? '',
  logoUrl: team.brand?.logoUrl ?? team.store?.logoUrl,
  isSelected: team.id === selectedTeamId,
});

export const buildTeamGroups = ({
  teams,
  selectedTeamId,
  translate,
}: BuildTeamGroupsParams): TeamSelectorGroup[] => {
  const selectableTeams = teams.filter((team) => !isNetworkAdmin(team));

  return [
    {
      label: translate(LangEnum.GLOBAL_BRANDS),
      items: selectableTeams.filter(isBrand).map((t) => toMenuItem(t, selectedTeamId)),
    },
    {
      label: translate(LangEnum.GLOBAL_STORES),
      items: selectableTeams.filter(isStore).map((t) => toMenuItem(t, selectedTeamId)),
    },
    {
      label: translate(LangEnum.GLOBAL_OTHERS),
      items: selectableTeams.filter(isOther).map((t) => toMenuItem(t, selectedTeamId)),
    },
  ].filter((g) => g.items.length > 0);
};
